<div class="flex flex-col bg-white -m-3" style="width: 300px">
  <div class="p-2 flex flex-col border-gray-300 border-b gap-y-1 w-full">
    <span class="font-bold text-lg text-gray-800">{{ data.date | date: 'longDate' }}</span>
    <div class="flex flex-col" *ngIf="data.noShowDrivers && data.noShowDrivers.length > 0">
      <span class="font-bold text-orange-500">No Shows:</span>
      <div class="fflex flex-row flex-wrap">
        <span *ngFor="let driver of data.noShowDrivers; trackBy: 'id' | trackByKey" class="text-gray-700">
          {{ driver.name }}
        </span>
      </div>
    </div>
    <div class="flex flex-col" *ngIf="data.excusedDrivers && data.excusedDrivers.length > 0">
      <span class="font-bold text-gray-600">Excused:</span>
      <div class="flex flex-row flex-wrap">
        <span *ngFor="let driver of data.excusedDrivers; trackBy: 'id' | trackByKey" class="text-gray-700">
          {{ driver.name }}
        </span>
      </div>
    </div>
  </div>
  <div class="flex flex-col p-2 bg-gray-200 gap-y-1" *ngIf="hitchesToday$$ | async as hitches">
    <span class="font-bold text-gray-700">On Hitch:</span>
    <div class="flex flex-row flex-wrap">
      <span *ngFor="let hitch of hitches; trackBy: 'id' | trackByKey" class="w-1/2 text-gray-600">{{
        hitch.driverName
      }}</span>
    </div>
  </div>
</div>
